<script setup lang="ts">

import { faChevronDown, faChevronUp, faPlus } from '@fortawesome/pro-regular-svg-icons'

import { AppIcon } from '@shared/ui/icons'
import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnPrimary } from '@shared/ui/buttons'

import { useLessonsAddMenu } from '../../model/lessons/lessons-add-menu.hook'

defineOptions({
  name: 'LessonsAddMenu',
})

const {
  refIsOpen,
  refContainer,
  refFloating,
  refFloatingStyles,
  singleUrl,
  recurringUrl,
  toggle,
  close,
} = useLessonsAddMenu()
</script>

<template>
  <div
    ref="refContainer"
    class="lessons-add-menu"
  >
    <BtnPrimary
      text="Add lesson"
      color="emerald"
      @click="toggle"
    >
      <template #iconLeft>
        <AppIcon :icon="faPlus" />
      </template>
      <template #iconRight>
        <AppIcon :icon="refIsOpen ? faChevronUp : faChevronDown" />
      </template>
    </BtnPrimary>
    <div
      v-if="refIsOpen"
      ref="refFloating"
      class="lessons-add-menu__floating"
      :style="refFloatingStyles"
    >
      <AppDropdown>
        <NuxtLink
          :to="singleUrl"
          class="lessons-add-menu__link"
          @click="close"
        >
          <AppDropdownItem
            tag="div"
            text="Single event"
            color="blue"
          />
        </NuxtLink>
        <!-- TODO(INFRA-731): recurring temporarily hidden; restore refCanCreateRecurring or remove entirely once decided -->
        <NuxtLink
          v-if="false"
          :to="recurringUrl"
          class="lessons-add-menu__link"
          @click="close"
        >
          <AppDropdownItem
            tag="div"
            text="Recurring event"
            color="blue"
          />
        </NuxtLink>
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./LessonsAddMenu.scss" />
